// Generated by ReScript, PLEASE EDIT WITH CARE


let baseRoute = "/settings";

let userRoute = baseRoute + "/user";

let shopsRoute = baseRoute + "/shops";

let labelPrinterRoute = baseRoute + "/label-printer";

let billingAccountBaseRoute = baseRoute + "/billing-account";

let electronicInvoicingRoute = baseRoute + "/electronic-invoicing";

let electronicInvoicingSetupRoute = baseRoute + "/electronic-invoicing/setup";

function billingAccountShowRoute(shopId, param) {
  if (shopId !== undefined) {
    return billingAccountBaseRoute + "/" + shopId;
  } else {
    return billingAccountBaseRoute;
  }
}

function billingAccountInvoicesRoute(shopId) {
  return billingAccountBaseRoute + "/" + shopId + "/invoices";
}

let shopsRequiredDataQuery = "required-data=true";

export {
  baseRoute,
  userRoute,
  shopsRoute,
  shopsRequiredDataQuery,
  labelPrinterRoute,
  billingAccountBaseRoute,
  electronicInvoicingRoute,
  electronicInvoicingSetupRoute,
  billingAccountShowRoute,
  billingAccountInvoicesRoute,
}
/* No side effect */
